var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfinity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250.614,
    height: 458.124,
    viewBox: "0 0 250.614 458.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.136,
    y1: 0.425,
    x2: 1.129,
    y2: 0.63,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#7fbfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#79bbde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#6bb1d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#53a0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#3189c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2581c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.067,
    y1: 0.425,
    x2: 1.074,
    y2: 0.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1.766,
    y1: 0.12,
    x2: 0.688,
    y2: 0.518,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2581c4",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12518",
    "data-name": "Group 12518",
    transform: "translate(4151 5433.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502",
    transform: "translate(-4151 -5001.071)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 125.307,
    cy: 12.672,
    rx: 125.307,
    ry: 12.672,
    transform: "translate(0 0)",
    fill: "#707070",
    opacity: 0.18
  })), /*#__PURE__*/React.createElement("g", {
    id: "Infinity_5",
    "data-name": "Infinity 5",
    transform: "translate(-4136.408 -5433.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M385.367,396.356q0,3.285-.2,6.552a108.5,108.5,0,0,1-1.727,13.674,112.118,112.118,0,0,1-5.876,20.155,116.208,116.208,0,0,1-7.807,16.06,118.523,118.523,0,0,1-39.491,40.809q-4.567,2.858-9.437,5.279a111.283,111.283,0,0,1-82.295,6.793c-.774-.24-1.549-.49-2.315-.748q-3.913-1.3-7.674-2.875c-.783-.329-1.558-.659-2.324-1.006-.125-.053-.249-.116-.374-.169a116.942,116.942,0,0,1-45.723-37.186c-.365-.5-.73-1-1.1-1.5a120.594,120.594,0,0,1-8.324-13.354c-.3-.552-.6-1.1-.881-1.665a118.755,118.755,0,0,1-6.81-15.935,111.7,111.7,0,0,1-3.8-13.781,106.738,106.738,0,0,1-2.279-21.1,100.786,100.786,0,0,1,2.6-23.467c4.184-18.179,12.9-33.358,21.989-45.118v-.009a145.84,145.84,0,0,1,12.179-13.817A129.511,129.511,0,0,1,210.762,299.4l.107-.027c.294-.089.588-.178.881-.258a252.028,252.028,0,0,1,95.328-8.529q3.085.307,5.991.677c.009,0,.018.009.027.009.694.08,1.389.169,2.065.258.107.018.2.027.312.045q2.631,1.255,5.181,2.617c.294.151.579.312.864.472A127.936,127.936,0,0,1,351.947,317.6v.009a123.2,123.2,0,0,1,8.484,9.6c1.487,1.87,2.92,3.784,4.282,5.733q1.375,1.936,2.653,3.926a115.178,115.178,0,0,1,11.493,23.12,106.563,106.563,0,0,1,3.65,12.2,105.2,105.2,0,0,1,2.858,24.17Z",
    transform: "translate(-156.936 -61.922)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M327.6,296.31A2.7,2.7,0,0,1,327.07,298c-.979,1.5-3.356,3-6.855,4.434-.018.009-.044.018-.062.027a86.116,86.116,0,0,1-12.366,3.721c-.338.08-.677.16-1.024.24a239.393,239.393,0,0,1-35.548,4.8c-5.689.383-11.2.579-16.407.614H254.8c-17.146.134-31.034-1.478-37.5-4.291-.285-.125-.552-.258-.81-.383a5.69,5.69,0,0,1-2.965-2.635,2.329,2.329,0,0,1-.16-.685,2.659,2.659,0,0,1,.036-.579,2.437,2.437,0,0,1,.187-.579,4.893,4.893,0,0,1,1.371-1.727c.169-.142.347-.285.525-.436a.269.269,0,0,0,.062-.044,18.185,18.185,0,0,1,2.395-1.469c8.618-4.487,28.488-8.537,51.8-10.078,18.953-1.255,35.877-.561,46.444,1.531a.033.033,0,0,1,.027.009c1.086.214,2.1.445,3.045.685.009,0,.018.009.027.009,4.246,1.1,7.042,2.475,7.968,4.086a2.466,2.466,0,0,1,.338,1.059Z",
    transform: "translate(-163.129 -61.816)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M202.949,346.176a210.047,210.047,0,0,0-21.5,46.557,37.773,37.773,0,0,1-21.6-15.1c4.184-18.179,12.9-33.358,21.989-45.118a32.96,32.96,0,0,0,21.106,13.661Z",
    transform: "translate(-157.256 -66.668)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M400.533,363.483a37.646,37.646,0,0,1-19.514,16.995,209.306,209.306,0,0,0-26.6-43.836,33.238,33.238,0,0,0,11.734-6.419,32.856,32.856,0,0,0,7.469-9.116,123.116,123.116,0,0,1,8.484,9.6c1.487,1.87,2.92,3.784,4.282,5.733q1.375,1.936,2.653,3.926a115.178,115.178,0,0,1,11.493,23.12Z",
    transform: "translate(-178.609 -65.416)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    width: 37.388,
    height: 26.706,
    rx: 6.711,
    transform: "translate(91.209 277.677) rotate(-3.806)",
    fill: "#2eb3bd",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M319.346,225.5a12.022,12.022,0,0,1-5.092,3.552A148.841,148.841,0,0,1,255.915,243.7q-1.829.08-3.606.107a148.239,148.239,0,0,1-37.382-4.166c-1.772-.436-3.454-.872-5.03-1.318a11.956,11.956,0,0,1-5.555-2.564,11.724,11.724,0,0,1-4.193-8.03L185.034,58.477a12.272,12.272,0,0,1,2.706-8.644,11.867,11.867,0,0,1,3.054-2.591,12.154,12.154,0,0,1,3.2-1.318H194a198.483,198.483,0,0,1,102.343-9.045c.107.009.232.027.365.045a12,12,0,0,1,4.077,1.318,10.948,10.948,0,0,1,1.959,1.318,12.332,12.332,0,0,1,4.2,8.03l15.108,169.254A12.4,12.4,0,0,1,319.346,225.5Z",
    transform: "translate(-160.016 -33.894)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 9.403,
    height: 82.628,
    transform: "translate(107.12 303.358) rotate(-3.562)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M385.452,416.917a108.5,108.5,0,0,1-1.727,13.674,186.354,186.354,0,0,1-28.274,18.25c-.08.045-.16.08-.24.125-40.569,21.152-77.923,21.437-92.7,21.375a220.745,220.745,0,0,1-81.093-16.666c-6.971-2.858-13.051-5.778-18.117-8.431a111.682,111.682,0,0,1-3.8-13.781c3.053,1.691,6.57,3.543,10.5,5.457a221.716,221.716,0,0,0,80.755,21.954c6.615.436,12.846.516,18.562.392,3.312-.08,6.445-.231,9.392-.436a182.167,182.167,0,0,0,25.372-3.383,196.955,196.955,0,0,0,53.094-19.906c5.1-2.786,10.354-5.938,15.677-9.49C377.8,422.757,382.016,419.615,385.452,416.917Z",
    transform: "translate(-157.217 -75.931)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M237.921,524.6q-3.913-1.3-7.674-2.875c-.783-.329-1.558-.659-2.324-1.006a106.221,106.221,0,0,0,.685-15.321,11.069,11.069,0,0,0-2.243-6.989,10.831,10.831,0,0,0-4.407-2.991,9.659,9.659,0,0,0-2.226-.436,204.555,204.555,0,0,1-37.907-11.618c-.365-.5-.73-1-1.095-1.5a120.577,120.577,0,0,1-8.324-13.354c.267.134.552.276.828.41a228.543,228.543,0,0,0,54.305,18.348,12.039,12.039,0,0,1,2.484.49,13.183,13.183,0,0,1,9.4,12.633A107.944,107.944,0,0,1,237.921,524.6Z",
    transform: "translate(-158.634 -81.593)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M397.229,454.921a116.207,116.207,0,0,1-7.807,16.06,204.936,204.936,0,0,1-34.4,15.472,9.428,9.428,0,0,0-2.154.73,10.926,10.926,0,0,0-3.988,3.525,11.109,11.109,0,0,0-1.309,7.229,107.335,107.335,0,0,0,2.359,13.852q-4.567,2.858-9.437,5.279a107.532,107.532,0,0,1-4.3-22.7,13.189,13.189,0,0,1,7.683-13.745,12.087,12.087,0,0,1,2.4-.8A228.9,228.9,0,0,0,397.229,454.921Z",
    transform: "translate(-176.597 -80.102)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M312.13,197.24c-2.644,1.175-5.057,2.368-7.22,3.517a9.713,9.713,0,0,0-4.255,3.338,12.294,12.294,0,0,0-2.146,5,13.717,13.717,0,0,0-.2,3.543l.4,6.027a105.27,105.27,0,0,1-59.584,9.009,109.271,109.271,0,0,1-12.757-2.573l-1.1-7.042a13.731,13.731,0,0,0-.988-3.41,12.282,12.282,0,0,0-3.2-4.407,9.588,9.588,0,0,0-4.887-2.315c-2.065-.57-4.327-1.122-6.766-1.629L195.1,45.924h.009a198.366,198.366,0,0,1,94.544-10.247c2.76.365,5.359.775,7.8,1.2.107.009.232.027.365.045L312.13,197.24Z",
    transform: "translate(-161.124 -33.894)",
    fill: "#353f44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_528",
    "data-name": "Rectangle 528",
    width: 32.107,
    height: 45.67,
    rx: 7,
    transform: "translate(53.223 64.486) rotate(-4.764)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    width: 32.107,
    height: 45.67,
    rx: 7,
    transform: "translate(95.97 60.924) rotate(-4.764)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M313.271,290.479c-11.653.392-28.2,4.843-40.257,13.06-3.027,2.065-9.018,6.579-18.206,8.3H254.8c-4.3.8-7.487.659-12.259.409-7.8-.409-19.274-1.985-25.239-4.7-.285-.125-.552-.258-.81-.383a6.073,6.073,0,0,1-2.965-2.635,2.325,2.325,0,0,1-.16-.685,2.655,2.655,0,0,1,.036-.579,2.892,2.892,0,0,1,.187-.579,5.41,5.41,0,0,1,1.371-1.727c.169-.143.347-.285.525-.436a.276.276,0,0,0,.062-.045c.481-.392.988-.8,1.513-1.211.294-.089.588-.178.881-.258,8.618-4.487,28.488-8.538,51.8-10.078,18.953-1.255,35.877-.561,46.444,1.531-.935-.027-1.905-.027-2.92.018Z",
    transform: "translate(-163.129 -61.816)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M401.8,396.962q0,3.285-.2,6.552a108.487,108.487,0,0,1-1.727,13.674A112.131,112.131,0,0,1,394,437.344,116.232,116.232,0,0,1,386.2,453.4,118.522,118.522,0,0,1,346.7,494.213q-4.567,2.858-9.437,5.279A110.85,110.85,0,0,1,309.616,509a159.9,159.9,0,0,0,21.117-14.832c12.579-10.434,28.079-23.3,36.794-45.892a88.076,88.076,0,0,0,3.837-12.713,92.493,92.493,0,0,0,1.967-13.425,132.7,132.7,0,0,0,.134-15.01C372.4,377.562,358.82,354.5,358.82,354.5c-4.8-8.578-13.4-23.552-31.056-35.21a88.022,88.022,0,0,0-21.085-10.171c1.854-.333,16.817-3.03,19.309-4.072a36.141,36.141,0,0,0,4.407-1.87c.018-.009.045-.018.062-.027a38.2,38.2,0,0,0,6.855-4.433,6.271,6.271,0,0,0,.187-2.751,3.592,3.592,0,0,0-.41-1.166,128.3,128.3,0,0,1,31.292,23.414v.009a123.116,123.116,0,0,1,8.484,9.6c1.487,1.87,2.92,3.784,4.282,5.733q1.375,1.936,2.653,3.926a115.19,115.19,0,0,1,11.493,23.12,106.584,106.584,0,0,1,3.65,12.2,105.192,105.192,0,0,1,2.858,24.17Z",
    transform: "translate(-173.37 -62.528)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M327.644,226.032a12.022,12.022,0,0,1-5.092,3.552,148.842,148.842,0,0,1-58.338,14.654q-1.829.08-3.606.107c26.85-6.615,46.311-13.113,53.451-17.458,1.87-1.131,5.84-3.543,7.914-8.306a17.965,17.965,0,0,0,.792-11.084q-5.675-67.85-11.075-135.71-1.322-16.505-2.608-33.01a10.949,10.949,0,0,1,1.959,1.318,12.331,12.331,0,0,1,4.2,8.03L330.35,217.379a12.4,12.4,0,0,1-2.706,8.653Z",
    transform: "translate(-168.314 -34.43)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M317.557,197.459c-2.644,1.175-5.057,2.368-7.22,3.516a9.713,9.713,0,0,0-4.255,3.338,12.294,12.294,0,0,0-2.145,5,13.718,13.718,0,0,0-.2,3.543l.4,6.027a105.27,105.27,0,0,1-59.584,9.009,226.852,226.852,0,0,0,40.987-14.974,39.107,39.107,0,0,0,5.929-3.16c18.66-13.087,14.253-45.812,9.5-98.123-1.594-17.556-3.784-43.48-5.884-75.742,2.76.365,5.359.775,7.8,1.2.107.009.232.027.365.045l14.315,160.316Z",
    transform: "translate(-166.551 -34.114)",
    fill: "#15192f",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M209.019,166.089q-4.55-56.976-9.1-113.952a136.58,136.58,0,0,1,13.453-4.748,139.841,139.841,0,0,1,44.71-5.539c-5.954,1.643-14.731,4.249-25.256,8.09-9.625,3.512-11.54,4.709-12.789,5.641-10.7,7.985-10.631,25-10.622,35.332.022,23.039-.207,47.24-.4,75.176Z",
    transform: "translate(-161.653 -34.757)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M214.928,241.288c-1.772-.436-3.454-.872-5.03-1.318a11.957,11.957,0,0,1-5.555-2.564,11.724,11.724,0,0,1-4.193-8.03L185.034,60.122a12.272,12.272,0,0,1,2.706-8.644,11.866,11.866,0,0,1,3.054-2.591c-.463,2.733-.908,5.956-1.22,9.57a117.99,117.99,0,0,0,0,20.182c2.706,33.171,4.06,49.765,5.938,71.612,2,23.262,6.668,46.311,7.514,69.644a25.9,25.9,0,0,0,1.585,8.306A29.1,29.1,0,0,0,214.928,241.288Z",
    transform: "translate(-160.016 -35.539)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M225.852,503.922a116.943,116.943,0,0,1-45.723-37.186c-.365-.5-.73-1-1.1-1.5a120.588,120.588,0,0,1-8.324-13.354c-.3-.552-.6-1.1-.881-1.665a118.754,118.754,0,0,1-6.81-15.935,111.7,111.7,0,0,1-3.8-13.781,106.739,106.739,0,0,1-2.279-21.1,100.787,100.787,0,0,1,2.6-23.467c4.184-18.179,12.9-33.358,21.989-45.118V330.8a145.847,145.847,0,0,1,12.179-13.817c-1.994,3.508-4.166,7.478-6.419,11.858-6.81,13.238-14.493,28.159-18.6,44.317-.65,2.573-7.006,28.7-.392,56.575C177.609,469.015,208.216,492.963,225.852,503.922Z",
    transform: "translate(-156.936 -64.964)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M337.631,296.695c-.409,1.754-1.7,3.1-3.6,4.291a.189.189,0,0,0-.053.036,53.348,53.348,0,0,1-8.2,3.695,64.3,64.3,0,0,1-20.9,4.336h-.071a124.383,124.383,0,0,0,12.268-4.336c8.733-3.605,13.131-5.466,14.244-8.707a7.1,7.1,0,0,0,.16-3.837c-.027-.116-.053-.24-.089-.365.107.018.2.027.312.045q2.631,1.255,5.181,2.617c.294.151.579.312.864.472A5.471,5.471,0,0,1,337.631,296.695Z",
    transform: "translate(-173.165 -62.2)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M271.015,365.267a5.735,5.735,0,0,1-5.038-6.078,5.72,5.72,0,0,1,2.07-4.069,5.584,5.584,0,0,1,2.97-1.087c3.37-.34,6.007,2,6.581,2.511.785.7,1.813,1.855,2.055,2.127.743.837.994,1.2,1.417,1.7a10.369,10.369,0,0,0,4.22,3.435,6.169,6.169,0,0,0,4.495.029,6.035,6.035,0,0,0,3.17-3.234,5.6,5.6,0,0,0,.268-3.917,5.349,5.349,0,0,0-1.259-2.032,5.915,5.915,0,0,0-2.317-1.5,7.468,7.468,0,0,0-6.423,1.43,13.347,13.347,0,0,0-1.683,1.5l-.161.177a14.91,14.91,0,0,0-1.729,2.414c-.585.969-.673,1.284-1.036,1.925a9.443,9.443,0,0,1-3.676,3.849A6.381,6.381,0,0,1,271.015,365.267Z",
    transform: "translate(-168.902 -68.909)",
    fill: "none",
    stroke: "#139093",
    strokeWidth: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.6c27e1f0e494bddc2ae3f027fead070c.svg";
export { ForwardRef as ReactComponent };